<template>
    <v-main class="stretch fill-height">
        <v-container fluid style="padding: 20px;" class="stretch fill-height ma-auto">
            <transition name="fade">
                <slot/>
            </transition>
        </v-container>

        <v-footer inset app>
            <v-row v-if="!shouldHideZapaLogo" style="direction: rtl; padding: 10px 4px;">
                <v-img alt="Zapa Client Portal"
                       src="../assets/images/Zapa-Client-Portals-170.png"
                       style="max-width: 60px; cursor: pointer; margin: 0;"/>
            </v-row>
        </v-footer>
    </v-main>
</template>

<script>
import {VueController} from "@/service/support/vuex-controller";

export default VueController('BaseContainerUnauth', {
    data() {
        return {
            publicOrgBranding: null
        }
    },
    created() {
        // Load cached branding from localStorage
        try {
            const cachedBranding = localStorage.getItem('publicOrgBranding');
            if (cachedBranding) {
                const brandingData = JSON.parse(cachedBranding);
                // Only use cache if it's for the current subdomain
                const hostname = window.location.hostname;
                const parts = hostname.split('.');
                const subdomain = parts.length >= 3 && parts[0] !== 'www' && parts[0] !== 'app' ? parts[0].toLowerCase() : null;
                
                if (subdomain && brandingData.subdomain === subdomain) {
                    this.publicOrgBranding = brandingData;
                }
            }
        } catch (error) {
            console.error("BaseContainerUnauth: Error loading cached branding:", error);
        }
    },
    computed: {
        shouldHideZapaLogo() {
            // Check public org branding from cache
            if (this.publicOrgBranding && this.publicOrgBranding.hideZapaLogo) {
                return true;
            }
            return false;
        }
    }
});
</script>

